import React, { Component } from 'react';

import { IonInput, IonItem, IonLabel, IonList, IonText, IonButton, IonSelect, IonSelectOption } from '@ionic/react';

import ProfileService from '../services/profile';
import countryCodes, { DEFAULT_COUNTRY_CODE } from '../utils/countryCodes';

class Profile extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();

    this.state = {
      profile: {},
      errors: {},
      disabled: false,
      prefix: DEFAULT_COUNTRY_CODE,
    };

    this.countryCodes = countryCodes;

    this.inputHandler = this.inputHandler.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.onEdit = this.onEdit.bind(this);
  }

  async componentDidMount() {
    try {
      const response = await ProfileService.me();
      const profile = response.data.data || {};

      // Estrai prefisso e numero dal telefono se presente
      if (profile.phone_number) {
        const phoneNumber = profile.phone_number;
        // Cerca il prefisso nei codici paese
        const foundCountry = this.countryCodes.find((country) => phoneNumber.startsWith(country.code));

        if (foundCountry) {
          const prefix = foundCountry.code;
          const number = phoneNumber.substring(prefix.length);
          this.setState({
            profile: { ...profile, phone_number: number },
            prefix,
          });
        } else {
          // Se non trova il prefisso, usa +39 come default
          this.setState({
            profile: { ...profile, phone_number: phoneNumber.replace(/^\+/, '') },
            prefix: DEFAULT_COUNTRY_CODE,
          });
        }
      } else {
        this.setState({ profile });
      }
    } catch (error) {
      console.error('Errore durante il caricamento del profilo:', error);
    }
  }

  async inputHandler(event) {
    let errors = this.state.errors;
    delete errors[event.target.name];

    let profile = this.state.profile;
    profile[event.target.name] = event.target.value;

    await this.setState({
      profile,
      errors,
    });
  }

  async handleValidation(event) {
    let errors = this.state.errors;
    let error = !!event.target ? event.target.firstChild.validationMessage : event.firstChild.validationMessage;
    let name = !!event.target ? event.target.name : event.name;

    delete errors[name];

    try {
      this.form.current[name].setCustomValidity('');
      this.form.current[name].reportValidity();
    } catch (error) {
      console.error(error);
    }

    if (name === 'password_confirmation') {
      this.handleValidation({ target: this.form.current.password.parentElement });
    }

    await this.setState({ errors });

    if (!!error) {
      errors[name] = error;
      await this.setState({ errors, disabled: true });
      return;
    }

    await this.setState({ disabled: false });
  }

  async onEdit(e) {
    e.preventDefault();

    let [name, email, password, password_confirmation, phone_number, codice_fiscale] = [
      e.target.name.value,
      e.target.email.value,
      e.target.password.value,
      e.target.password_confirmation.value,
      `${e.target.prefix.value}${e.target.phone_number.value}`.replaceAll(' ', '').replaceAll('-', ''),
      e.target.codice_fiscale.value,
    ];

    try {
      let response = await ProfileService.update({
        name,
        email,
        password,
        password_confirmation,
        phone_number,
        codice_fiscale,
      });

      if (!!this.props.onSubmit) {
        this.props.onSubmit(null, response);
      }
    } catch (error) {
      if (error.response) {
        const errorData = error.response.data;

        // Gestione errori sotto `error`
        if (errorData.error) {
          let response = errorData.error;
          for (const key in response) {
            if (response.hasOwnProperty(key)) {
              if (key === 'privacy') {
                await this.setState({ errors: { privacy: response[key][0] } });
                continue;
              }
              if (this.form.current[key]) {
                this.form.current[key].setCustomValidity('');
                this.form.current[key].setCustomValidity(response[key]);
                this.form.current[key].reportValidity();
                this.handleValidation({ target: this.form.current[key].parentElement });
              }
            }
          }
        }

        // Gestione errori sotto `errors`
        if (errorData.errors) {
          for (const key in errorData.errors) {
            if (errorData.errors.hasOwnProperty(key)) {
              const message = errorData.errors[key][0];
              if (this.form.current[key]) {
                this.form.current[key].setCustomValidity('');
                this.form.current[key].setCustomValidity(message);
                this.form.current[key].reportValidity();
                this.handleValidation({ target: this.form.current[key].parentElement });
              } else {
                this.setState((prevState) => ({
                  errors: {
                    ...prevState.errors,
                    [key]: message,
                  },
                }));
              }
            }
          }
        }
      }

      if (!!this.props.onSubmit) {
        this.props.onSubmit(error);
      }
    }
  }

  render() {
    const { errors, profile } = this.state;

    return (
      <form ref={this.form} onSubmit={this.onEdit}>
        <IonList lines="full" className="ion-no-margin ion-no-padding">
          <IonItem>
            <IonLabel color={!!errors.name ? 'danger' : null} position="stacked">
              Nome e cognome
            </IonLabel>
            <IonInput
              type="text"
              name="name"
              onIonBlur={this.handleValidation}
              onIonChange={this.inputHandler}
              value={profile.name || ''}
              required
            />
            {!!errors.name ? <IonText color="danger">{errors.name}</IonText> : null}
          </IonItem>

          <IonItem>
            <IonLabel color={!!errors.phone_number ? 'danger' : null} position="stacked">
              Numero di telefono
            </IonLabel>
            <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
              <IonSelect
                name="prefix"
                value={this.state.prefix}
                onIonChange={(e) => this.setState({ prefix: e.detail.value })}
                interface="action-sheet"
                style={{ maxWidth: '120px' }}
              >
                {this.countryCodes.map((country, index) => (
                  <IonSelectOption key={index} value={country.code}>
                    {country.code} {country.country}
                  </IonSelectOption>
                ))}
              </IonSelect>
              <IonInput
                name="phone_number"
                type="tel"
                required
                placeholder="3201234567"
                pattern="[0-9]{7,15}"
                value={profile.phone_number || ''}
                onIonBlur={this.handleValidation}
                onIonChange={this.inputHandler}
                style={{ flex: 1 }}
              />
            </div>
            {!!errors.phone_number ? <IonText color="danger">{errors.phone_number}</IonText> : null}
          </IonItem>

          <IonItem>
            <IonLabel color={!!errors.codice_fiscale ? 'danger' : null} position="stacked">
              Codice fiscale
            </IonLabel>
            <IonInput
              type="text"
              name="codice_fiscale"
              required
              minlength={16}
              maxlength={16}
              pattern="^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$"
              onIonBlur={this.handleValidation}
              onIonChange={this.inputHandler}
              value={profile.codice_fiscale || ''}
              style={{ textTransform: 'uppercase' }}
            />
            {!!errors.codice_fiscale ? <IonText color="danger">{errors.codice_fiscale}</IonText> : null}
          </IonItem>

          <IonItem>
            <IonLabel color={!!errors.email ? 'danger' : null} position="stacked">
              Email
            </IonLabel>
            <IonInput
              type="email"
              name="email"
              onIonBlur={this.handleValidation}
              onIonChange={this.inputHandler}
              value={profile.email || ''}
              required
            />
            {!!errors.email ? <IonText color="danger">{errors.email}</IonText> : null}
          </IonItem>

          <IonItem>
            <IonLabel color={!!errors.password ? 'danger' : null} position="stacked">
              Password <small>( lascia vuota per non cambiare )</small>
            </IonLabel>
            <IonInput
              type="password"
              name="password"
              clearInput={true}
              onIonBlur={this.handleValidation}
              onIonChange={this.inputHandler}
            />
            {!!errors.password ? <IonText color="danger">{errors.password}</IonText> : null}
          </IonItem>

          <IonItem>
            <IonLabel color={!!errors.password_confirmation ? 'danger' : null} position="stacked">
              Conferma password <small>( lascia vuota per non cambiare )</small>
            </IonLabel>
            <IonInput
              type="password"
              name="password_confirmation"
              clearInput={true}
              onIonBlur={this.handleValidation}
              onIonChange={this.inputHandler}
            />
            {!!errors.password_confirmation ? <IonText color="danger">{errors.password_confirmation}</IonText> : null}
          </IonItem>
        </IonList>

        <div className="ion-padding">
          <IonButton expand="block" type="submit" className="ion-no-margin" disabled={this.state.disabled}>
            Aggiorna
          </IonButton>
        </div>
      </form>
    );
  }
}

export default Profile;
